import React, { ReactElement } from 'react';
import classNames from 'classnames';
import BoxListItemRow from './component/BoxListItemRow';
import BoxListItemType from './BoxListItemType';

interface Props {
  dataList?: BoxListItemType[],
  className?: string;
}

const renderBoxListItemRows = (list: BoxListItemType[]): ReactElement[] => {
  const rows = new Array<ReactElement>();
  for (let i = 0; i < list.length; i += 3) {
    rows.push(<BoxListItemRow key={i} itemList={list.slice(i, i + 3)} />);
  }
  return rows;
};

const BoxList = (
  {
    dataList,
    className,
  }
    : Props,
): ReactElement => {
  const classes: string = classNames('box-list', className);
  return (
    <div className={classes}>
      {
        dataList && dataList.length > 0 && (renderBoxListItemRows(dataList))
      }
    </div>
  );
};
export default BoxList;
